
import { defineComponent } from "vue";
import LuxAvatar from "@/modern/components/lux/LuxAvatar.vue";

export default defineComponent({
  name: "lux-upsell",
  components: { LuxAvatar },
  setup() {
    // O checkout é outra aplicação, não uma rota do SPA. Mesmo destino usado
    // pelo UpgradeMembershipBanner do dashboard.
    function openPlans() {
      const url = `${process.env.VUE_APP_CHECKOUT_URL}/plans`;
      window.open(url, "_blank", "noopener,noreferrer");
    }

    return { openPlans };
  },
});
